import { useState } from "react";
import { AppDialog } from "../../components/AppDialog";

/** An Area row buffered under a City (M:N). `oid` set ⇒ an EXISTING area being linked/edited. */
export interface AreaRow {
  oid?: string;
  areaName: string;
}

interface Props {
  initial?: AreaRow;
  onOk: (row: AreaRow) => void;
  onClose: () => void;
}

/**
 * The legacy "Area" leaf popup — the 4th level of Country ▸ State ▸ City ▸ Area (owner request
 * 2026-10-23, image 846). Area Name only (dbo.Area is just AreaName; its M:N with City is the
 * City popup's Area grid). A pure in-memory editor — persisted on the Country dialog's final OK,
 * where each city's areas are created and linked via dbo.City_Areas.
 */
export function AreaDialog({ initial, onOk, onClose }: Props) {
  const [areaName, setAreaName] = useState(initial?.areaName ?? "");
  const [tried, setTried] = useState(false);

  const ok = () => {
    setTried(true);
    if (!areaName.trim()) return;
    onOk({ oid: initial?.oid, areaName: areaName.trim() });
  };

  return (
    <AppDialog
      open
      title="Area"
      icon="ti-map-2"
      width={420}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="ca-btn" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="ca-btn ca-btn-solid" onClick={ok}>
            OK
          </button>
        </>
      }
    >
      <div className="cd-form">
        <div className="cd-field">
          <label className="cd-label" htmlFor="area-name">
            Area:<span className="req">*</span>
          </label>
          <input
            id="area-name"
            className={`op-input${tried && !areaName.trim() ? " required-empty" : ""}`}
            value={areaName}
            onChange={(e) => setAreaName(e.target.value)}
          />
        </div>
      </div>
    </AppDialog>
  );
}
